import { render, staticRenderFns } from "./FlowchartBlock.vue?vue&type=template&id=c0447de0&scoped=true"
import script from "./FlowchartBlock.vue?vue&type=script&lang=js"
export * from "./FlowchartBlock.vue?vue&type=script&lang=js"
import style0 from "./FlowchartBlock.vue?vue&type=style&index=0&id=c0447de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0447de0",
  null
  
)

export default component.exports